<template>
  <div>
    <Navbar activeDirectory="dati" activePage="reports"></Navbar>
    <div class="container-fluid py-4">
      <!-- ===== PAGE HEADER ===== -->
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
        <div class="d-flex align-items-center">
          <div class="au-header-icon mr-3">
            <i class="mdi mdi-file-document-outline"></i>
          </div>
          <div class="text-left">
            <h3 class="mb-0 font-weight-bold text-dark text-uppercase">Reports</h3>
            <p class="mb-0 text-muted small">Genera ed esporta i report giornalieri in formato PDF</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6 offset-md-3">
          <div class="au-card">
            <h5 class="mb-4 text-center font-weight-bold text-primary">Esporta Report Giornaliero</h5>
            
            <label class="cw-label">Commessa</label>
            <div class="cw-select-wrap mb-4">
              <select class="cw-select" v-model="lotto">
                <template v-if="commesse.length > 0">
                  <option v-for="c in commesse" :key="c.id" :value="String(c.id)">{{ c.nome }}</option>
                </template>
                <template v-else>
                  <option value="1">Commessa 1</option>
                  <option value="2">Commessa 2</option>
                </template>
              </select>
              <i class="mdi mdi-chevron-down cw-select-arrow"></i>
            </div>
            
            <label class="cw-label">Per il giorno</label>
            <div class="cw-input-wrap mb-4">
              <input type="date" class="cw-input" v-model="date" />
            </div>

            <div class="text-center">
              <button class="cw-btn-submit w-100 justify-content-center" @click="download()" :disabled="printing">
                <i class="mdi mdi-file-pdf-box mr-2" style="font-size: 1.2rem;"></i>
                {{ printing ? 'Generazione in corso...' : 'Scarica Report PDF' }}
              </button>
              <div class="mt-3 text-muted small">
                <i class="mdi mdi-information-outline mr-1"></i>
                Report per <strong>{{ getCommessaNome(lotto) }}</strong> del <strong>{{ formatDate(date) }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { contextStore } from "@/utils/contextStore";

export default {
  components: {
    Navbar
  },

  data() {
    return {
      date: new Date().toISOString().split("T")[0],
      printing: false
    };
  },

  computed: {
    contextStore() {
      return contextStore;
    },
    lotto: {
      get() {
        return contextStore.activeCommessaId || "1";
      },
      set(val) {
        contextStore.setCommessa(val);
      }
    },
    commesse() {
      return contextStore.commesse;
    }
  },

  async mounted() {
    await contextStore.fetchCommesse();
  },

  methods: {
    fetchCommesse() {
      return contextStore.fetchCommesse();
    },

    getCommessaNome(lottoId) {
      const found = this.commesse.find(c => String(c.id) === String(lottoId));
      return found ? found.nome : 'Commessa ' + lottoId;
    },

    formatDate(dt) {
      if (dt){
        var _dt = dt.split('-')
        return `${_dt[2]}/${_dt[1]}/${_dt[0]}`
      } else {
        return ''
      }
      
    },

    download() {
      this.printing=true;
      this.axios.get(`report/${this.lotto}/${this.date}`,{responseType: 'blob'}).then(response=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `commessa_${this.lotto}_report_${this.date}.pdf`);
        document.body.appendChild(link);
        link.click();
        this.printing=false;
      })
    }
  }
};
</script>

<style scoped>
/* =========================================
   REPORTS — Premium UI (RoadME DS)
   ========================================= */

/* ── Shared tokens from style.md ── */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-input:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
}
.cw-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── Page-specific ── */

/* Header icon */
.au-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.au-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }
</style>